import { combineReducers } from 'redux';
import list from './list';
import create from './create';
import update from './update';
import show from './show';
import change from './change';

export default combineReducers({
  list, create, update, show, change,
});
